import { set, startOfMonth } from 'date-fns'
import { getDay } from 'date-fns/getDay'
import range from 'lodash-es/range'

import {
  DEFAULT_DATE_LOCALE,
  WEEK_DAYS,
  WEEK_FIRST_DAY,
} from '../../../constants/date'
import { mod } from '../../../utils/number'

import { MONTH_DAYS_COUNT } from './MonthDays.constants'

/**
 * @param {Date} value
 * @param {number} date
 *
 * @returns {Date}
 */
function getMonthDay(value, date) {
  return set(value, { date, hours: 0, milliseconds: 0, minutes: 0, seconds: 0 })
}

/**
 * @param {Date} value
 * @param locale
 *
 * @returns Date[]
 */
export function getMonthDays(value, locale = DEFAULT_DATE_LOCALE) {
  const weekStart = locale.options.weekStartsOn ?? WEEK_FIRST_DAY
  const monthStart = getDay(startOfMonth(value))

  const dateStart = 1 - mod(monthStart - weekStart, WEEK_DAYS)
  const dateEnd = dateStart + MONTH_DAYS_COUNT

  return range(dateStart, dateEnd).map(date => getMonthDay(value, date))
}
